import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as space from '../../../../space'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Associated space',
    isOptional: false,
    name: 'Space',
    partialId: PartialId.Standard.create('space'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(space.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
